export default __webpack_public_path__ + "assets/images/Payment_01.633593.webp";